import React from 'react';
import defaultHeader from './header.html.txt';

export default function Variant() {
    return (
        <div
            data-testid="universal-header"
            dangerouslySetInnerHTML={{
                __html: defaultHeader
            }}
        />
    );
}
